const REQUIRED_CONFIG_KEYS = [
    'BACKEND_URL',
    'OIDC_ISSUER_URL',
    'OIDC_CLIENT_ID',
    'OIDC_REDIRECT_URI',
    'OIDC_LOGOUT_URI',
];

let runtimeConfig;

const validateConfig = (config) => {
    const missingKeys = REQUIRED_CONFIG_KEYS.filter(
        (key) => typeof config[key] !== 'string' || !config[key].trim(),
    );

    if (missingKeys.length > 0) {
        throw new Error(`Не заданы обязательные параметры: ${missingKeys.join(', ')}`);
    }

    return Object.freeze(config);
};

export const loadRuntimeConfig = async () => {
    const response = await fetch(
        `${process.env.PUBLIC_URL}/runtime-config.json`,
        {cache: 'no-store'},
    );

    if (!response.ok) {
        throw new Error(`Не удалось загрузить runtime-конфиг: HTTP ${response.status}`);
    }

    runtimeConfig = validateConfig(await response.json());
};

export const getRuntimeConfig = () => {
    if (!runtimeConfig) {
        throw new Error('Runtime-конфиг запрошен до загрузки');
    }

    return runtimeConfig;
};
